import "./water-mark.css";
import { WaterMark } from './water-mark';
export default WaterMark;